export default __webpack_public_path__ + "static/media/imgLight6.26e455e6.png";